// components/admin/AdminShellOnfit.jsx
import IconRail from "./IconRail";

export default function AdminShellOnfit({ children }) {
  return (
    <div className="h-screen bg-gray-50 text-gray-900 flex flex-col md:flex-row">
      <div className="hidden md:block">
        <IconRail />
      </div>

      <div className="flex-1 min-w-0 min-h-0 grid grid-rows-[auto,1fr]">
        <div className="md:hidden">
          <IconRail />
        </div>

        <main className="row-start-2 min-h-0 h-full overflow-y-auto px-4 md:px-8 py-6 md:py-6">
          {children}
        </main>
      </div>
    </div>
  );
}
